export default {
  root: {
    dashboard: 'dashboard',
    dashboard_main: 'dashboard_main',
    trials_hub: 'trials_hub',
    patient: 'patient',
    conversations: 'conversations',
    calendar: 'calendar',
    integration: 'integration',
    admin_location: 'admin_location',
    admin_recruiter: 'admin_recruiter',
    admin_userAccess: 'admin_useraccess'
  },
  dashboard: {
    dashboard_view: 'dashboard_view', //done
  },
  trials_hub: {
    trial_view: 'trial_view', //done
    add_trial: 'trial_add', //done
    edit_trial: 'trial_edit', //done
    toggle_trial_active_inactive: 'trial_active_inactive', //done
    view_trial_patient: 'trial_patient_view', //done
    reroute_trial_patient: 'trial_patient_reroute', //done
    assign_trial_patient: 'trial_patient_assign', //done
    delete_trial_patient: 'trial_patient_delete', //done
    change_trial_patient_status: 'trial_patient_statuschange', //done
    call_trial_patient: 'trial_patient_call', //done
    chat_with_trial_patient: 'trial_patient_chat', //done
    export_trial_data: 'trial_export' //done
  },
  patient: {
    view_patient: 'patient_view', //done
    add_patient: 'patient_add', //done
    edit_patient: 'patient_edit', //done
    export_patient_data: 'patient_export' //done
  },
   calendar: {
    my_calendar: 'my_calendar', //done
    group_calendar: 'group_calendar', //done
    filter_calendar: 'filter_calendar', // done
    calendar_view_type: 'calendar_view_type' //done
  },
  conversations: {
    view_patient_conversations: 'patientconversation_view', // need to ask
    outbound_conversation: 'patientconversation_outbound', // need to ask
    conversation_note: 'patientconversation_note', //done
    add_event_to_conversation: 'patientconversation_addevent', //done
    chat_details: 'patientconversation_chatdetails' //done
  },
  integration: {
    facebook_integration: 'integration_facebook',  //done
    microsoft_calendar_integration: 'integration_microsoft_calendar' //done
  },
  admin_location: {
    view_location: 'location_view', //done
    add_location: 'location_add', //done
    edit_location: 'location_edit',   //done
    export_location_data: 'location_export' //done
  },
  admin_recruiter: {
    view_recruiter: 'recruiter_view', //done
    add_recruiter: 'recruiter_add', //done
    edit_recruiter: 'recruiter_edit', //done
    export_recruiter: 'recruiter_export' //done
  },
  admin_userAccess: {
    view_user_access: 'useraccess_view',
    view_permissions: 'permission_view',
    edit_permissions: 'permission_edit', // done
    add_role: 'add_role', // done
    add_user: 'add_user', // done
    inactivate_user: 'inactive_user'
  }
}
